import { Props } from '@components/BlockMapper';
import { Button } from '@components/Button/';
import Block from '@components/Layout/Block';

// STYLING
import { FC } from 'react';
import {
  CircleImageBox,
  Container,
  ContentContainer,
  Eyebrow,
  Header,
  ImageBox,
  StackedItem,
  StyledVerticalLineSeparator,
  Text,
} from './styles';
import { getTestId } from '@util/getTestIds';

const StackedTextAndImageBlock: FC<Props> = (props) => {
  const {
    eyebrow,
    header,
    img,
    bodyText,
    ctaText,
    ctaUrl,
    eyebrow2,
    header2,
    img2,
    bodyText2,
    ctaText2,
    ctaUrl2,
    buttonExternalOption,
    buttonExternalOption2,
    imageCircle,
    imageCircle2,
    reverse,
  } = props;

  const itemOneTestId = eyebrow ? getTestId(eyebrow) : '';
  const itemTwoTestId = eyebrow2 ? getTestId(eyebrow2) : '';

  return (
    <Block background="secondaryBg" className="home-page-about-us-content">
      <Container $reverse={reverse}>
        <StackedItem data-testid={`${itemOneTestId}-section`}>
          <StyledVerticalLineSeparator />
          {imageCircle ? (
            <CircleImageBox>
              {' '}
              {img && <img data-testid={`${itemOneTestId}-img`} src={img} />}
            </CircleImageBox>
          ) : (
            <ImageBox> {img && <img data-testid={`${itemOneTestId}-img`} src={img} />}</ImageBox>
          )}

          <ContentContainer $reverse={reverse}>
            {eyebrow && <Eyebrow data-testid={`${itemOneTestId}-eyebrow`}>{eyebrow}</Eyebrow>}
            {header && <Header data-testid={`${itemOneTestId}-header`}>{header}</Header>}
            <Text data-testid={`${itemOneTestId}-description`}>{bodyText as string}</Text>
            {ctaUrl && ctaText && (
              <Button
                arrow={true}
                dataTestId={`${itemOneTestId}-cta`}
                variant={'tertiary'}
                url={ctaUrl}
                label={ctaText}
                target={buttonExternalOption}
              />
            )}
          </ContentContainer>
        </StackedItem>
        <StackedItem data-testid={`${itemTwoTestId}-section`}>
          <StyledVerticalLineSeparator />
          {imageCircle2 ? (
            <CircleImageBox>
              {' '}
              {img2 && <img data-testid={`${itemTwoTestId}-img`} src={img2} />}
            </CircleImageBox>
          ) : (
            <ImageBox> {img2 && <img data-testid={`${itemTwoTestId}-img`} src={img2} />}</ImageBox>
          )}
          <ContentContainer $reverse={reverse}>
            {eyebrow2 && <Eyebrow data-testid={`${itemTwoTestId}-eyebrow`}>{eyebrow2}</Eyebrow>}
            {header2 && <Header data-testid={`${itemTwoTestId}-header`}>{header2}</Header>}
            <Text data-testid={`${itemTwoTestId}-description`}>{bodyText2}</Text>
            {ctaUrl2 && ctaText2 && (
              <Button
                arrow={true}
                dataTestId={`${itemTwoTestId}-cta`}
                variant={'tertiary'}
                url={ctaUrl2}
                label={ctaText2}
                target={buttonExternalOption2}
              />
            )}
          </ContentContainer>
        </StackedItem>
      </Container>
    </Block>
  );
};

export default StackedTextAndImageBlock;
